import { FetchMethod, fetchWrapper } from './FetchWrapper';

import { BasisOfAccountingPreference } from '../Models/Api/strongbox.models';
import { LenderConnectionOptions } from '../Utils/ConnectStrongbox';
import { knownAccountingGroupIds } from '../Models/AccountingCollectionGroup';
import {
    PortalCreateSubmissionRequestOptions,
    PortalDefaultBasisOfAccounting
} from '../Models/PortalCreateSubmissionRequestOptions';

import { LogException, LogMessage, SeverityLevel } from './Logging';

import { IDelegatedAccessToken } from '@finagraph/strongbox-nexus-client';

export async function getDelegatedToken(eid: string): Promise<IDelegatedAccessToken> {
    try {
        // jsonHeaders true, requireAuth false
        let url = `/api/Workspaces/${eid}/DelegatedAccessTokens`;

        LogMessage(
            `getDelegatedToken invoked`,
            SeverityLevel.Information,
            {
                workspaceId: eid,
            }
        );

        const response = await fetchWrapper(
            url,
            {
                method: FetchMethod.Post
            },
            true,
            false
        );

        LogMessage(
            `getDelegatedToken response received`,
            SeverityLevel.Information,
            {
                workspaceId: eid,
                statusCode: response.status
            }
        );

        var authData: IDelegatedAccessToken = await response.json();
        if (authData) {
            LogMessage(
                `getDelegatedToken response read successfully`,
                SeverityLevel.Information,
                {
                    workspaceId: eid,
                    statusCode: response.status,
                }
            );
        } else {
            throw new Error('UnexpectedApiFailure');
        }

        return authData;
    } catch (e) {

        LogException(
            `failure processing getDelegatedToken request/response`,
            e,
        );

        throw e;
    }
}

export function GetFinancialsImportOptions(src: PortalCreateSubmissionRequestOptions): LenderConnectionOptions {
    let mostRecentDate = undefined;

    if ((src.mostRecentPeriodYear) &&
        (src.mostRecentPeriodMonth !== undefined) &&
        (src.mostRecentPeriodDay !== undefined) &&
        (src.mostRecentPeriodMonth >= 0)) {

        mostRecentDate = {
            month: src.mostRecentPeriodMonth,
            year: src.mostRecentPeriodYear,
            day: src.mostRecentPeriodDay,
        }
    }

    const basisOfAccountingPreference: BasisOfAccountingPreference = src.basisOfAccountingPreference || PortalDefaultBasisOfAccounting;

    const txns = src.accountingCollectionGroups.get(knownAccountingGroupIds.transactions);
    const financialStatements = src.accountingCollectionGroups.get(knownAccountingGroupIds.financialStatements);
    const payables = src.accountingCollectionGroups.get(knownAccountingGroupIds.accountsPayable);
    const receivables = src.accountingCollectionGroups.get(knownAccountingGroupIds.accountsReceivable);

    return {
        mostRecentDate,
        anonymizeCustomersAndVendors: src.anonymizeCustomersAndVendors,
        provideUserCopy: src.provideUserCopy,
        financialStatementsPeriod: !!financialStatements?.collect ?
            {
                reportingPeriod: 'FiscalYears',
                numberOfPeriods: src.fullFiscalYearsToCollect + 1,
                basisOfAccountingPreference,
            } :
            undefined,
        transactionsPeriod: !!txns?.collect ?
            {
                reportingPeriod: 'FiscalYears',
                numberOfPeriods: src.fullFiscalYearsToCollect + 1,
                basisOfAccountingPreference,
            } :
            undefined,
        receivablesPeriod: !!receivables?.collect ?
            {
                reportingPeriod: 'FiscalYears',
                numberOfPeriods: src.fullFiscalYearsToCollect + 1,
            } :
            undefined,
        payablesPeriod: !!payables?.collect ?
            {
                reportingPeriod: 'FiscalYears',
                numberOfPeriods: src.fullFiscalYearsToCollect + 1,
            } :
            undefined,
    };
}
